// extracted by mini-css-extract-plugin
export default {"placeholder":"avatarV2__placeholder__gazbf"};